// tslint:disable:max-line-length

import React from 'react';

export const ActionSearch = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M6.5,0C2.9,0,0,2.9,0,6.5S2.9,13,6.5,13c1.2,0,2.4-0.4,3.4-1c0,0,0,0,0,0l3.5,3.5c0.6,0.6,1.5,0.6,2.1,0 c0.6-0.6,0.6-1.5,0-2.1c0,0,0,0,0,0l-3.5-3.5c0,0,0,0,0,0c0.6-1,1-2.2,1-3.4C13,2.9,10.1,0,6.5,0z M6.5,2C9,2,11,4,11,6.5 S9,11,6.5,11S2,9,2,6.5S4,2,6.5,2z" />
    </svg>
  );
};
